export default "__VITE_ASSET__BMlz$S5F__"